exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DownloadUploader{margin:0 auto;width:482px}@media only screen and (max-width: 620px){.DownloadUploader{width:288px}}.DownloadUploader-header{font-weight:500;margin-bottom:60px}.DownloadUploader-header-title{font-size:24px;margin-bottom:12px}.DownloadUploader-header-details{font-size:16px}.DownloadUploader-panel{margin-bottom:64px}.GlookoResearchSiteDesc{font-size:16px}", ""]);

// exports
